import React, { useState, useContext } from "react";
import { EmailInput } from "./Inputs";
import "../css/login.css";
import { AlertsContext } from "./Layout";
import { Link, useParams} from "react-router-dom";
import { postStuff } from "../helpers/auth.js";



function ResetPasswordPage() {
    const [emailInput, setEmailInput] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const addAlertBanner = useContext(AlertsContext);

    const {new_account} = useParams()

    const handleSubmit = (event) => {
        event.preventDefault();
        setErrorMessage("");
        if (emailInput === "") {
            setErrorMessage("Vyplňte všechny údaje");
            return;
        }
        setIsLoading(true);

        const body = {
            email: emailInput.trim().toLowerCase()
        }

        postStuff("auth/users/reset_password/", body).then((res) => {
            console.log(res)
          try {
            setIsLoading(false);
            if (res.status === 204) {
              addAlertBanner("Odeslání e-mailu proběhlo úspěšně, zkontrolujte schránku", "success", 5000);
            }
            else if (res.status === 400) {
              addAlertBanner("Váš e-mail neznáme", "danger");
            }
            else {
              addAlertBanner("Něco se pokazilo", "danger");
            }
          } catch (err) {
            addAlertBanner("Něco se pokazilo", "danger");
          }
        });

    };

    return (
        <>
            <main className="mainContent">
                <header className="banner">
                    <img
                        loading="lazy"
                        src="/img/logo_text_bg.png"
                        alt="Peer Sight Logo"
                    />
                    <section className="systemInfo">Chytrý evidenční systém</section>
                </header>
                <section className="loginSection">
                    <form className="loginForm" onSubmit={handleSubmit}>
                        {!new_account ? 
                        <p className="formTitle">Resetování hesla</p>
                            : <p className="formTitle">Pro nastavení hesla zadejte e-mail</p>
                    }<label htmlFor="email" className="visually-hidden">
                            Enter your email
                        </label>
                        <EmailInput emailInput={emailInput} setEmailInput={setEmailInput} />

                        <button type="submit" className="submitButton" disabled={isLoading}>
                            Zaslat potvrzovací email
                        </button>
                        {errorMessage && <div className="form-error-mess">{errorMessage}</div>}
                    </form>
                    <div className="login-info">
                        <div className="forgotPassword">
                            Znáte přihlašovací údaje? {" "}
                            <Link to="/login" className="resetLink">
                                přihlašte se
                            </Link>
                            
                        </div>
                        <p className="accountRequest">
                            Pro vytvoření uživatelského účtu požádejte administrátora vaší
                            organizace.
                        </p>
                    </div>
                </section>
            </main>
        </>
    );
}

export default ResetPasswordPage;